import PropTypes from 'prop-types';

/**
 * @typedef {Object} ThemeColors
 * @property {string} color100
 * @property {string} color200
 * @property {string} color300
 * @property {string} color400
 * @property {string} color500
 * @property {string} color600
 * @property {string} color700
 * @property {string} color800
 * @property {string} color900
 */

export const ThemeColorsPropType = PropTypes.shape({
  color100: PropTypes.string,
  color200: PropTypes.string,
  color300: PropTypes.string,
  color400: PropTypes.string,
  color500: PropTypes.string,
  color600: PropTypes.string,
  color700: PropTypes.string,
  color800: PropTypes.string,
  color900: PropTypes.string
});
